import { Link } from 'react-router';

import { buildQueryString } from '../../../../../Buyer/utils/queryParams';

/**
 * The payments page searches `reference` among its search fields, so the term
 * lands the seller on the pay link behind this payment.
 *
 * Not `SafeLink`: its `to` is typed to a route path and can't carry a query
 * param. `buildQueryString` is still what supplies the whitelisted params, so
 * an impersonated `state_key` survives the hop.
 */
export const LatestPaymentReferenceLink = ({
  reference,
}: {
  reference: string;
}) => (
  <Link
    to={`/pay/payments/${buildQueryString({ search: reference })}`}
    className="text-xs font-reg text-primary-40 underline"
  >
    {`REF - ${reference}`}
  </Link>
);
